import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "page-hero career-hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "career-tags" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "home-features" }
const _hoisted_7 = { class: "section jobs-section" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "job-list-card" }
const _hoisted_10 = { class: "job-main" }
const _hoisted_11 = { class: "job-action" }
const _hoisted_12 = { class: "job-pills" }
const _hoisted_13 = { class: "job-list-card parttime-card" }
const _hoisted_14 = { class: "job-main" }
const _hoisted_15 = { class: "job-action" }
const _hoisted_16 = { class: "job-pills" }
const _hoisted_17 = { class: "job-list-card training-card" }
const _hoisted_18 = { class: "job-main" }
const _hoisted_19 = { class: "job-action" }
const _hoisted_20 = { class: "job-pills" }
const _hoisted_21 = { class: "application-modal" }
const _hoisted_22 = {
  key: 0,
  class: "application-success"
}
const _hoisted_23 = { class: "modal-heading" }
const _hoisted_24 = { class: "field-row" }
const _hoisted_25 = { class: "field-row" }
const _hoisted_26 = { class: "upload-grid" }
const _hoisted_27 = { class: "upload-card" }
const _hoisted_28 = { class: "upload-card" }
const _hoisted_29 = { class: "privacy-check" }
const _hoisted_30 = {
  key: 0,
  class: "form-error"
}
const _hoisted_31 = ["disabled"]

import {ref} from 'vue';
import {
  ArrowRight,
  Check,
  CheckCircle2,
  Clock3,
  FileText,
  HeartHandshake,
  Send,
  Sparkles,
  Upload,
  Users,
  X
} from 'lucide-vue-next';
import '@/assets/styles/career.css'
import '@/assets/styles/upload-fix.css'
import '@/assets/styles/jobs-fix.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'CareerView',
  setup(__props) {

const open = ref(false), sending = ref(false), success = ref(false), error = ref('');
const resume = ref<File | null>(null), cover = ref<File | null>(null)
const form = ref({
  position: 'Festanstellung im Praxisteam',
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  workModel: 'Vollzeit',
  message: '',
  privacy: false
})

function openApplication(position: string, workModel: string) {
  form.value.position = position;
  form.value.workModel = workModel;
  open.value = true;
}

function pick(e: Event, type: 'resume' | 'cover') {
  const file = (e.target as HTMLInputElement).files?.[0] || null;
  if (type === 'resume') resume.value = file; else cover.value = file
}

async function submit() {
  if (!resume.value) {
    error.value = 'Bitte laden Sie Ihren Lebenslauf als PDF hoch.';
    return;
  }
  sending.value = true;
  error.value = '';
  await new Promise(resolve => setTimeout(resolve, 800));
  success.value = true;
  sending.value = false
}

function close() {
  open.value = false;
  success.value = false;
  error.value = ''
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "eyebrow" }, "Karriere in unserer Praxis", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("h1", null, [
          _createTextVNode("Arbeiten, wo der Mensch"),
          _createElementVNode("br"),
          _createElementVNode("em", null, "im Mittelpunkt steht.")
        ], -1)),
        _cache[17] || (_cache[17] = _createElementVNode("p", null, "Ein herzliches Team, moderne Zahnmedizin und ein Arbeitsplatz, an dem Professionalität und gutes Miteinander zusammengehören.", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, [
            _createVNode(_unref(Check)),
            _cache[12] || (_cache[12] = _createTextVNode(" Vollzeit möglich", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(Check)),
            _cache[13] || (_cache[13] = _createTextVNode(" Teilzeit möglich", -1))
          ]),
          _createElementVNode("span", null, [
            _createVNode(_unref(Check)),
            _cache[14] || (_cache[14] = _createTextVNode(" Moderne Praxis", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "section-heading" }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", { class: "eyebrow" }, "Das erwartet Sie"),
            _createElementVNode("h2", null, [
              _createTextVNode("Ein Team, in dem man"),
              _createElementVNode("br"),
              _createTextVNode("gerne ankommt.")
            ])
          ]),
          _createElementVNode("p", null, "Wir arbeiten strukturiert, unterstützen einander und legen Wert auf eine offene, freundliche Atmosphäre – im Team genauso wie im Umgang mit unseren Patientinnen und Patienten.")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createVNode(_unref(HeartHandshake)),
            _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Starkes Miteinander", -1)),
            _cache[19] || (_cache[19] = _createElementVNode("p", null, "Kurze Wege, gegenseitige Unterstützung und ein respektvoller Umgang.", -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(Sparkles)),
            _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Moderner Arbeitsplatz", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("p", null, "Ein hochwertiges Praxisumfeld mit anspruchsvoller Zahnmedizin.", -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(Clock3)),
            _cache[22] || (_cache[22] = _createElementVNode("h3", null, "Passendes Arbeitsmodell", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("p", null, "Die aktuelle Stelle ist sowohl in Vollzeit als auch in Teilzeit möglich.", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "jobs-heading" }, [
          _createElementVNode("span", { class: "eyebrow" }, "Offene Stellen"),
          _createElementVNode("h2", null, "Vielleicht passen wir zusammen."),
          _createElementVNode("p", null, "Für den ersten Schritt reichen wenige Angaben. Ihre Unterlagen können Sie direkt hochladen.")
        ], -1)),
        _createElementVNode("article", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "job-status" }, "Aktuell gesucht", -1)),
            _cache[29] || (_cache[29] = _createElementVNode("h3", null, [
              _createTextVNode("Verstärkung für unser Praxisteam "),
              _createElementVNode("small", null, "(m/w/d)")
            ], -1)),
            _cache[30] || (_cache[30] = _createElementVNode("p", null, "Sie sind zuverlässig, arbeiten gerne mit Menschen und möchten Ihre Stärken in einer modernen Zahnarztpraxis einbringen? Wir freuen uns auf Ihre Bewerbung.", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[25] || (_cache[25] = _createTextVNode(" Freude am Umgang mit Menschen ", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[26] || (_cache[26] = _createTextVNode(" Zuverlässige und sorgfältige Arbeitsweise ", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[27] || (_cache[27] = _createTextVNode(" Teamgeist und freundliches Auftreten ", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, [
                _createVNode(_unref(Clock3)),
                _cache[31] || (_cache[31] = _createTextVNode(" Vollzeit", -1))
              ]),
              _createElementVNode("span", null, [
                _createVNode(_unref(Users)),
                _cache[32] || (_cache[32] = _createTextVNode(" Musterstadt", -1))
              ])
            ]),
            _createElementVNode("button", {
              class: "button primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openApplication('Festanstellung in Vollzeit','Vollzeit')))
            }, [
              _cache[33] || (_cache[33] = _createTextVNode("Jetzt bewerben ", -1)),
              _createVNode(_unref(ArrowRight))
            ])
          ])
        ]),
        _createElementVNode("article", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "job-status parttime-status" }, "Teilzeitstelle", -1)),
            _cache[38] || (_cache[38] = _createElementVNode("h3", null, [
              _createTextVNode("Verstärkung in Teilzeit "),
              _createElementVNode("small", null, "(m/w/d)")
            ], -1)),
            _cache[39] || (_cache[39] = _createElementVNode("p", null, "Sie möchten Beruf und Privatleben gut miteinander verbinden und trotzdem Teil eines engagierten Praxisteams sein? Wir suchen zuverlässige Unterstützung in Teilzeit.", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[34] || (_cache[34] = _createTextVNode(" Flexible Teilzeitbeschäftigung", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[35] || (_cache[35] = _createTextVNode(" Freude am Kontakt mit Patientinnen und Patienten", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[36] || (_cache[36] = _createTextVNode(" Sorgfältige, selbstständige Arbeitsweise", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, [
                _createVNode(_unref(Clock3)),
                _cache[40] || (_cache[40] = _createTextVNode(" Teilzeit", -1))
              ]),
              _createElementVNode("span", null, [
                _createVNode(_unref(Users)),
                _cache[41] || (_cache[41] = _createTextVNode(" Musterstadt", -1))
              ])
            ]),
            _createElementVNode("button", {
              class: "button primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openApplication('Teilzeitstelle im Praxisteam','Teilzeit')))
            }, [
              _cache[42] || (_cache[42] = _createTextVNode("In Teilzeit bewerben ", -1)),
              _createVNode(_unref(ArrowRight))
            ])
          ])
        ]),
        _createElementVNode("article", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "job-status training-status" }, "Ausbildungsplatz", -1)),
            _cache[47] || (_cache[47] = _createElementVNode("h3", null, [
              _createTextVNode("Ausbildung in unserer Zahnarztpraxis "),
              _createElementVNode("small", null, "(m/w/d)")
            ], -1)),
            _cache[48] || (_cache[48] = _createElementVNode("p", null, "Du möchtest in einen abwechslungsreichen medizinischen Beruf starten, arbeitest gerne mit Menschen und suchst ein Team, das dich zuverlässig begleitet? Dann lerne unsere Praxis kennen.", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[43] || (_cache[43] = _createTextVNode(" Interesse an Medizin und Zahnheilkunde", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[44] || (_cache[44] = _createTextVNode(" Freundlichkeit und Freude am Umgang mit Menschen", -1))
              ]),
              _createElementVNode("li", null, [
                _createVNode(_unref(Check)),
                _cache[45] || (_cache[45] = _createTextVNode(" Lernbereitschaft, Sorgfalt und Teamgeist", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", null, [
                _createVNode(_unref(Sparkles)),
                _cache[49] || (_cache[49] = _createTextVNode(" Ausbildung", -1))
              ]),
              _createElementVNode("span", null, [
                _createVNode(_unref(Users)),
                _cache[50] || (_cache[50] = _createTextVNode(" Musterstadt", -1))
              ])
            ]),
            _createElementVNode("button", {
              class: "button primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (openApplication('Ausbildung in der Zahnarztpraxis','Ausbildung')))
            }, [
              _cache[51] || (_cache[51] = _createTextVNode("Ausbildung starten ", -1)),
              _createVNode(_unref(ArrowRight))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "application-overlay",
              onClick: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: "modal-close",
                  "aria-label": "Schließen",
                  onClick: close
                }, [
                  _createVNode(_unref(X))
                ]),
                (success.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_unref(CheckCircle2)),
                      _cache[53] || (_cache[53] = _createElementVNode("h2", null, "Vielen Dank!", -1)),
                      _cache[54] || (_cache[54] = _createElementVNode("p", null, "Ihre Bewerbung wurde erfolgreich übermittelt. Wir melden uns persönlich bei Ihnen.", -1)),
                      _createElementVNode("button", {
                        class: "button primary",
                        onClick: close
                      }, "Schließen")
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[55] || (_cache[55] = _createElementVNode("span", { class: "eyebrow" }, "Direkt bewerben", -1)),
                        _createElementVNode("h2", null, "Bewerbung: " + _toDisplayString(form.value.position), 1),
                        _cache[56] || (_cache[56] = _createElementVNode("p", null, "Füllen Sie das Formular aus und laden Sie Ihre Unterlagen bequem als PDF hoch.", -1))
                      ]),
                      _createElementVNode("form", {
                        class: "contact-form application-form",
                        onSubmit: _withModifiers(submit, ["prevent"])
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", null, [
                            _cache[57] || (_cache[57] = _createElementVNode("span", null, "Vorname *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.firstName) = $event)),
                              required: "",
                              placeholder: "Max"
                            }, null, 512), [
                              [_vModelText, form.value.firstName]
                            ])
                          ]),
                          _createElementVNode("label", null, [
                            _cache[58] || (_cache[58] = _createElementVNode("span", null, "Nachname *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.lastName) = $event)),
                              required: "",
                              placeholder: "Mustermann"
                            }, null, 512), [
                              [_vModelText, form.value.lastName]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("label", null, [
                            _cache[59] || (_cache[59] = _createElementVNode("span", null, "E-Mail *", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.email) = $event)),
                              required: "",
                              type: "email",
                              placeholder: "mail@beispiel.de"
                            }, null, 512), [
                              [_vModelText, form.value.email]
                            ])
                          ]),
                          _createElementVNode("label", null, [
                            _cache[60] || (_cache[60] = _createElementVNode("span", null, "Telefon", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.phone) = $event)),
                              type: "tel",
                              placeholder: "+49 …"
                            }, null, 512), [
                              [_vModelText, form.value.phone]
                            ])
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[62] || (_cache[62] = _createElementVNode("span", null, "Gewünschtes Arbeitsmodell", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.workModel) = $event))
                          }, [...(_cache[61] || (_cache[61] = [
                            _createElementVNode("option", null, "Vollzeit", -1),
                            _createElementVNode("option", null, "Teilzeit", -1),
                            _createElementVNode("option", null, "Offen für beides", -1),
                            _createElementVNode("option", null, "Ausbildung", -1)
                          ]))], 512), [
                            [_vModelSelect, form.value.workModel]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[63] || (_cache[63] = _createElementVNode("span", null, "Kurze Nachricht *", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.message) = $event)),
                            required: "",
                            rows: "4",
                            placeholder: "Erzählen Sie uns kurz etwas über sich …"
                          }, null, 512), [
                            [_vModelText, form.value.message]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("label", _hoisted_27, [
                            _createElementVNode("input", {
                              required: "",
                              type: "file",
                              accept: "application/pdf,.pdf",
                              onChange: _cache[9] || (_cache[9] = ($event: any) => (pick($event,'resume')))
                            }, null, 32),
                            _createVNode(_unref(Upload)),
                            _createElementVNode("span", null, [
                              _cache[64] || (_cache[64] = _createElementVNode("strong", null, "Lebenslauf hochladen *", -1)),
                              _createElementVNode("small", null, _toDisplayString(resume.value ? resume.value.name : 'PDF auswählen'), 1)
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_28, [
                            _createElementVNode("input", {
                              type: "file",
                              accept: "application/pdf,.pdf",
                              onChange: _cache[10] || (_cache[10] = ($event: any) => (pick($event,'cover')))
                            }, null, 32),
                            _createVNode(_unref(FileText)),
                            _createElementVNode("span", null, [
                              _cache[65] || (_cache[65] = _createElementVNode("strong", null, "Anschreiben hochladen", -1)),
                              _createElementVNode("small", null, _toDisplayString(cover.value ? cover.value.name : 'PDF auswählen'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.privacy) = $event)),
                            required: "",
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, form.value.privacy]
                          ]),
                          _createElementVNode("span", null, [
                            _cache[67] || (_cache[67] = _createTextVNode("Ich stimme der Verarbeitung meiner Bewerbungsdaten gemäß ", -1)),
                            _createVNode(_component_router_link, { to: "/datenschutz" }, {
                              default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                                _createTextVNode("Datenschutzerklärung", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[68] || (_cache[68] = _createTextVNode(" zu.", -1))
                          ])
                        ]),
                        (error.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(error.value), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "button primary submit-application",
                          disabled: sending.value
                        }, [
                          _createVNode(_unref(Send)),
                          _createTextVNode(" " + _toDisplayString(sending.value ? 'Wird übermittelt …' : 'Bewerbung senden'), 1)
                        ], 8, _hoisted_31)
                      ], 32)
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})